import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"change-indicator"},[_c(VIcon,{staticClass:"progressIcon",attrs:{"color":_vm.getHighlightColor(_vm.value),"small":""}},[_vm._v(" "+_vm._s(_vm.getProgressionIcon(_vm.value))+" ")]),_c('span',{style:({ color: _vm.getHighlightColor(_vm.value) })},[_vm._v(" "+_vm._s(_vm._f("formatPercentageChange")(_vm.value))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }